import React from "react";
import { BsArrowReturnRight } from "react-icons/bs";
import SpinnerSmall from "components/SpinnerSmall";
import { CiCircleCheck } from "react-icons/ci";
import { FaLongArrowAltRight } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { clickGiveButton } from "features/landingPageSlice";
import { useTranslation } from "react-i18next";

export default function GivingExample() {
  const { t } = useTranslation("marketing");

  const [enlarge, setEnlarge] = React.useState(false);
  const { giveBtnClicked, giveBtnLoading } = useSelector(
    (state) => state.landingPage,
  );
  const dispatch = useDispatch();

  return (
    <div
      className="giving-example-container"
      onMouseEnter={() => setEnlarge(true)}
      onMouseLeave={() => setEnlarge(false)}
    >
      {giveBtnClicked ? (
        <div className="giving-example-thankyou">
          <div className="giving-example-thankyou-content">
            <CiCircleCheck size={32} color="white" />
            <span>
              {t("demo.giftSent", {
                church: t("demo.churchName"),
                amount: "$100",
              })}
            </span>
          </div>
          <div className="giving-example-thankyou-footer">
            <FaLongArrowAltRight />
            <span>
              <img
                src={"/church.png"}
                alt="giving-example"
                style={{
                  marginLeft: "30px",
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </span>
          </div>
        </div>
      ) : (
        <div className="giving-example-wrapper">
          <div
            onMouseEnter={() => setEnlarge(false)}
            className="giving-example-preview"
            style={{
              transform: enlarge ? "scale(1.06)" : "scale(1)",
              transition: "all 0.3s ease",
            }}
          >
            <div className="giving-example-header">
              <img
                src={"/avatar1.png"}
                alt="giving-example"
                className="giving-example-image"
              />
              <h3>{t("demo.youAreGiving")}</h3>
            </div>
            <div className="giving-example-amount">
              <h4>$100</h4>
            </div>
            <div className="giving-example-footer">
              <span> To </span>
              <BsArrowReturnRight />
              <div className="giving-example-church">
                <img
                  src={"/church.png"}
                  alt="giving-example"
                  style={{
                    border: "1px solid #ccc",
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <span>{t("demo.churchName")}</span>
              </div>
            </div>
          </div>
          <div
            onMouseEnter={() => setEnlarge(false)}
            onClick={() => {
              dispatch(clickGiveButton());
            }}
            className="giving-example-submit-button"
          >
            <button className="give-button">
              {giveBtnLoading ? (
                <div class="spinner">
                  <SpinnerSmall />
                </div>
              ) : (
                "Give Now"
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
